import React, { useState } from 'react';
import { Form, Transition, Link, Document } from 'components';
import { api, isEmail } from 'helpers';
import { errors } from '.';
import css from './short.scss';

export function Restore(props) {
  const [ state, setState ] = useState({});

  async function submit({ values, setError, setPending, setSuccess }) {
    if (!values.email) {
      return setError('email', 'please enter your email');
    } else if (!isEmail(values.email)) {
      return setError('email', 'please enter valid email');
    }
    setPending();
    try {
      await api('/reset-password/', { email: values.email });
      setSuccess();
    } catch ({ error }) {
      setError('email', errors[error] || 'Error. Please try again');
    }
    setPending(false);
  }

  return (
    <Transition in={props.active} mountOnEnter unmountOnExit classNames={css.locals} timeout={500}>
      <Form onSubmit={submit} state={state} setState={setState} className={css('form', 'appear'+props.status)} autoComplete="off">
        <Document.Title>Restore Password</Document.Title>
        <p><Form.Text name="email" label="Email" /></p>
        <p><Form.Submit>Restore</Form.Submit></p>
        <p className={css.footer}>
          Remember your password? <Link to={`/login/${window.location.search}`}>Login</Link>
        </p>
        { state.success &&
          <div className={css.header}>
            <p>Email with password restoration link has been sent to {state.email}</p>
          </div>
        }
      </Form>
    </Transition>
  );

}
